import SiafLiteApiRepository from "../../external/siafLiteApi";

class TipoContribuinteClienteService {
  constructor() {
    this.urlBase = "/integracao/tipo-contribuinte-cliente";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default TipoContribuinteClienteService;
